import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'

import { BUTTONS_STYLE } from './styles'

const useStyles = createUseStyles({
  button: {
    ...BUTTONS_STYLE,
    color: '#90734F',
    textTransform: 'lowercase',
  },
})

interface Props {
  title: string
  onClick: () => void
}

export const NavButton: FC<Props> = flowMax(
  addDisplayName('NavButton'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ title, onClick, classes }) => (
    <button onClick={onClick} className={classes.button}>
      {title}
    </button>
  )
)
